
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Goatopunecab() {



    const cardData =
    {
        keyword: 'Goa to Pune Cab',
        heading: 'S9 Travels: Goa to Pune Cab',
        headingDescription: 'S9 Travels offers Goa to Pune Cab Service, ensuring a comfortable, safe, and hassle-free journey. Whether you are heading back from a beach vacation or traveling for business, our well-maintained cabs, including spacious Innova vehicles, provide a smooth and enjoyable ride. Enjoy on-time pickups, professional drivers, affordable pricing, and 24/7 service for a seamless travel experience. Book your Goa to Pune Cabs with S9 Travels and enjoy a stress-free journey with comfort and convenience!',


        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "A historic fortification in the heart of Pune, Shaniwar Wada was built in 1732 by the Peshwas of the Maratha Empire. Once the seat of the Peshwa rulers, this grand palace is known for its magnificent architecture, massive gateways, and intriguing legends. The evening light and sound show offers a captivating retelling of its history, making it a must-visit for history lovers."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892 by Sultan Muhammed Shah Aga Khan III, this stunning palace holds great historical significance. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters during the Indian independence movement. The palace is surrounded by lush gardens and houses a museum displaying artifacts related to Gandhi's life and legacy."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Perched atop a hill, Sinhagad Fort offers breathtaking panoramic views of the surrounding landscape. This fort, which was the site of the historic Battle of Sinhagad in 1670, is a favorite among trekking enthusiasts. Visitors can explore the ruins, pay homage to the brave warrior Tanaji Malusare, and enjoy local delicacies like pithla bhakri at nearby food stalls."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene retreat for spiritual seekers. It offers a variety of meditation programs, wellness sessions, and yoga classes in a peaceful environment. The ashram attracts visitors from across the globe looking to rejuvenate their mind and body through mindfulness and meditation."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An ancient rock-cut temple dedicated to Lord Shiva, Pataleshwar Cave Temple dates back to the 8th century. Carved out of a single basalt rock, this temple features beautiful stone pillars and a sanctum with a Shiva Lingam. The tranquil atmosphere makes it an ideal spot for those seeking a blend of history, spirituality, and ancient architecture."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This unique museum houses an extensive collection of over 20,000 artifacts, including sculptures, paintings, weapons, musical instruments, and everyday household items from different periods of Indian history. It provides a fascinating insight into the artistic heritage of Maharashtra and India as a whole."
    },
    {
      "title": "Khadakwasla Dam",
      "description": "A scenic getaway just a short drive from Pune, Khadakwasla Dam is a perfect spot for nature lovers and picnickers. The dam, which supplies water to Pune, offers stunning views of the reservoir and nearby hills. The cool breeze and peaceful surroundings make it an excellent location for a leisurely evening outing."
    },
    {
      "title": "Fergusson College Road",
      "description": "Known for its vibrant and youthful energy, Fergusson College Road is a popular hangout spot among students and young travelers. It is lined with cafes, bookstores, street vendors, and shopping outlets. Whether you're looking for trendy fashion, delicious street food, or a lively atmosphere, this street has something for everyone."
    },
    {
      "title": "Lal Mahal",
      "description": "A historically significant landmark, Lal Mahal was originally built in the 1630s by Shahaji Bhosale for his son, Chhatrapati Shivaji Maharaj. Though the original structure was destroyed, the reconstructed Lal Mahal offers a glimpse into the childhood of Shivaji Maharaj and features paintings and artifacts related to his life."
    },
    {
      "title": "Pune-Okayama Friendship Garden",
      "description": "Also known as the Japanese Garden, this beautifully designed landscape park is inspired by the Korakuen Garden in Okayama, Japan. It features manicured lawns, flowing streams, koi ponds, and traditional Japanese-style architecture. It's a perfect place for a peaceful stroll or a relaxing family outing."
    }
],

"services": [
  {
    "name": "Goa to Pune Cab Service",
    "description": "Book a reliable and comfortable cab from Goa to Pune with S9 Travels. Whether you're traveling for business, leisure, or a special occasion, we offer both one-way and round-trip services tailored to your needs. Our experienced drivers and well-maintained vehicles ensure that your journey from Goa to Pune is smooth, safe, and enjoyable."
  },
  {
    "name": "Book Goa to Pune Taxi",
    "description": "Booking a taxi from Goa to Pune is simple and hassle-free with S9 Travels. Whether you prefer a one-way trip or need the flexibility of a round-trip, we offer reliable and timely taxi services. Our fleet of clean, comfortable cars and professional chauffeurs guarantee a smooth and enjoyable ride from Goa to Pune."
  },
  {
    "name": "Affordable Goa to Pune Cab",
    "description": "Travel affordably from Goa to Pune with S9 Travels. Our budget-friendly Goa to Pune cab services provide you with a comfortable and reliable ride without compromising on quality. Whether it's a short one-way trip or a round-trip, we ensure a smooth journey at affordable prices."
  },
  {
    "name": "Private Taxi for Pune from Goa",
    "description": "Travel privately and comfortably with a dedicated taxi from Goa to Pune. Our private taxis offer a personalized travel experience, ensuring that your journey from Goa to Pune is uninterrupted and tailored to your preferences. Choose from a variety of vehicles to suit your needs and enjoy a peaceful ride."
  },
  {
    "name": "Goa to Pune One-Way or Round Trip",
    "description": "S9 Travels offers flexible one-way and round-trip taxi options from Goa to Pune. Whether you need a quick one-way journey or the convenience of a round-trip service, we have options to suit your schedule. Our professional drivers ensure a timely and comfortable ride from Goa to Pune throughout the journey."
  },
  {
    "name": "Comfortable Taxi Ride from Goa to Pune",
    "description": "Experience a comfortable and relaxing ride from Goa to Pune with S9 Travels. Our well-maintained vehicles and experienced chauffeurs ensure that you enjoy a smooth, stress-free journey, whether you're traveling for business, leisure, or a special event."
  },
  {
    "name": "Luxury Cab for Goa to Pune",
    "description": "Indulge in luxury while traveling from Goa to Pune with S9 Travels. Our fleet of luxury cabs offers the highest level of comfort and style, equipped with top-notch amenities for your comfort. Whether you're traveling solo or with a group, enjoy a premium ride with professional chauffeurs ensuring a smooth and luxurious journey."
  },
  {
    "name": "Group Travel from Goa to Pune by Taxi",
    "description": "Planning a group trip from Goa to Pune? S9 Travels offers spacious taxis that can accommodate large groups, ensuring that your journey is comfortable and enjoyable. Whether you're traveling with family, friends, or colleagues, our vehicles provide ample space and a smooth ride for everyone."
  },
  {
    "name": "Pune Sightseeing Tour from Goa by Cab",
    "description": "Explore the vibrant city of Pune with a personalized sightseeing tour from Goa by taxi. Visit famous landmarks such as Shaniwar Wada, Aga Khan Palace, Osho Ashram, and more. Our professional drivers ensure that you experience the best of Pune with a customized itinerary, while you travel in comfort and style."
  },
  {
    "name": "Goa to Pune Trip by Private Taxi",
    "description": "Book a private taxi for your trip from Goa to Pune and enjoy a comfortable, personalized journey. Whether you're traveling for business, leisure, or sightseeing, our private taxis provide the privacy and comfort you need. Our experienced drivers ensure that your ride is smooth, safe, and enjoyable from Goa to Pune."
  }
],

"tableData": [
  ["Goa to Pune Cab Service", "Book Goa to Pune Taxi"],
  ["Affordable Goa to Pune Cab", "Private Taxi for Pune from Goa"],
  ["Goa to Pune One-Way or Round Trip", "Comfortable Taxi Ride from Goa to Pune"],
  ["Luxury Cab for Goa to Pune", "Group Travel from Goa to Pune by Taxi"],
  ["Pune Sightseeing Tour from Goa by Cab", "Goa to Pune Trip by Private Taxi"],
  ["", ""]
],






"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Reliable Long-Distance Travel",
    "WhyChoosedescription": "S9 Travels offers a comfortable Goa to Pune cab service, perfect for long-distance journeys. Our fleet of well-maintained vehicles, including the Toyota Innova, ensures a smooth, comfortable ride with ample space, air conditioning, and plush seating, making your trip enjoyable no matter the distance."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand that timely travel is essential. Our Goa to Pune cab service ensures punctual pick-ups and drop-offs, so you can reach your destination on time without any delays. Whether you're traveling for business, leisure, or a special event, we guarantee reliable service every time."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes and road conditions for trips from Goa to Pune. They prioritize safety, comfort, and efficiency, ensuring your journey is smooth and pleasant, no matter the destination."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for the Goa to Pune cab service. We provide a transparent pricing structure with no hidden charges. You’ll receive a clear breakdown of the cost during the booking process, allowing you to plan your travel budget without surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Pune Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features like GPS tracking, airbags, and seat belts to ensure a safe and comfortable journey for you and your passengers throughout your trip from Goa to Pune."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Goa to Pune trip. Whether you need an early morning departure or a late-night return, we’re here to provide reliable service that fits your travel schedule."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Pune Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you need to make stops along the way, have specific locations to visit, or require special arrangements, we offer customizable itineraries to suit your preferences and make your Goa to Pune journey even more enjoyable."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Goa to Pune cab with S9 Travels is simple and hassle-free. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance. We strive to make your booking process quick, easy, and convenient."
  }
]




















    }


    const faqData = [
        [
          {
            question: 'How can I book a cab from Goa to Pune with S9 Travels?',
            answer: 'Booking a cab from Goa to Pune is simple! You can book your ride via our website, mobile app, or by contacting our customer service team for personalized assistance. We ensure a comfortable and hassle-free journey to Pune.',
          },
          {
            question: 'What types of vehicles are available for a trip from Goa to Pune?',
            answer: 'We offer a variety of vehicles for your trip from Goa to Pune, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the vehicle that best suits your needs based on group size and preferences.',
          },
          {
            question: 'Are the drivers experienced for the Goa to Pune trip?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes for the Goa to Pune journey. They prioritize your safety, comfort, and ensure a smooth travel experience.',
          },
          {
            question: 'Can I book a round-trip cab from Goa to Pune?',
            answer: 'Yes, you can book a round-trip cab for your journey from Goa to Pune. Simply provide us with your return details, and we will ensure a smooth and timely return journey.',
          },
          {
            question: 'How long in advance should I book a cab for Goa to Pune?',
            answer: 'It is recommended to book your cab at least 1-2 days in advance to ensure vehicle availability. However, last-minute bookings can also be accommodated depending on availability.',
          },
          {
            question: 'Is there a fixed fare for the Goa to Pune cab service?',
            answer: 'The fare for the Goa to Pune trip depends on the distance, vehicle type, and any special requests. Contact us for a personalized quote with transparent pricing based on your trip details.',
          },
          {
            question: 'Do you offer pick-up services from Goa airport or hotels for the Pune trip?',
            answer: 'Yes, we offer convenient pick-up services from Goa airport or hotels. Our professional drivers will ensure smooth transfer to your cab for a comfortable journey to Pune.',
          },
          {
            question: 'Can I request additional stops along the way during my trip to Pune?',
            answer: 'Yes, we can customize your itinerary to add stops for meals, sightseeing, or other breaks during your trip to Pune. Just let us know during booking to include your preferred stops.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Goa to Pune trip?',
            answer: 'Any extra charges for waiting time or detours will be communicated to you upfront during the booking process. We ensure full transparency in our pricing.',
          },
          {
            question: 'Why should I choose S9 Travels for my Goa to Pune trip?',
            answer: 'S9 Travels offers reliable, safe, and comfortable cab services for your journey from Goa to Pune. With well-maintained vehicles, experienced drivers, and excellent customer service, we ensure a smooth and enjoyable trip.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Goa to Pune with S9 Travels, and the experience was great. The driver was professional, and the vehicle was clean and well-maintained. The journey was smooth, and we arrived in Pune right on time. I highly recommend their services for long-distance travel!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip from Goa to Pune with S9 Travels was fantastic. The vehicle was spacious, and the driver was friendly and experienced. The scenic route was beautiful, and we had a very comfortable ride. We will definitely use S9 Travels for our future trips.”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

      
   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Goa to Pune Cabs",
  "image": "https://www.s9travels.com/images/keyword/67.jpg",
  "description": "Hire Goa to Pune cabs with S9 Travels for a smooth, affordable, and hassle-free journey. We offer well-maintained AC cars including hatchbacks, sedans, SUVs, and luxury vehicles for one-way and round-trip travel. Our experienced drivers ensure timely pickup, safe travel, and customer satisfaction from Goa to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "S9 Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7521"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.s9travels.com/goa-to-pune-cab"
  }
};

//     const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Goa to Pune Cabs",
//   "image": "https://www.s9travels.com/images/keyword/67.jpg",
//   "description": "Hire Goa to Pune cabs with S9 Travels for a smooth, affordable, and hassle-free journey. We offer well-maintained AC cars including hatchbacks, sedans, SUVs, and luxury vehicles for one-way and round-trip travel. Our experienced drivers ensure timely pickup, safe travel, and customer satisfaction from Goa to Pune.",
//   "brand": {
//     "@type": "Brand",
//     "name": "S9 Travels"
//   },
//   "sku": "G2P-001",
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.9",
//     "ratingCount": "7521"
//   },
//   "review": [
//     {
//       "@type": "Review",
//       "author": { "@type": "Person", "name": "Anil Shah" },
//       "datePublished": "2025-07-15",
//       "reviewBody": "Clean and comfortable cab, punctual driver. Excellent Goa to Pune cab service by S9 Travels!",
//       "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
//     },
//     {
//       "@type": "Review",
//       "author": { "@type": "Person", "name": "Priya Deshmukh" },
//       "datePublished": "2025-06-30",
//       "reviewBody": "Affordable rates and smooth ride. Would recommend S9 Travels for Goa to Pune cabs.",
//       "reviewRating": { "@type": "Rating", "ratingValue": "4", "bestRating": "5" }
//     }
//   ],
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "5499",
//     "priceValidUntil": "2025-12-31",
//     "availability": "https://schema.org/InStock",
//     "url": "https://www.s9travels.com/goa-to-pune-cab"
//   }
// };

      
// showing 4:5
      


    return (
        <div>
            {/* <Helmet>
      <title>Goa to Pune Cabs | S9 Travels</title>
      <meta
        name="description"
        content="Book Goa to Pune cabs with S9 Travels for safe, affordable, and on-time travel. One-way & round-trip AC cabs available with professional drivers. Instant booking & 24x7 support."
      />
    
    
      <link rel="canonical" href="https://www.s9travels.com/goa-to-pune-cab" />
     
     
      <meta property="og:title" content="Goa to Pune Cabs | Affordable AC Taxi Booking | S9 Travels" />
      <meta property="og:description" content="Book Goa to Pune cabs with S9 Travels for safe, affordable, and on-time travel. One-way & round-trip AC cabs available with professional drivers. Instant booking & 24x7 support." />
      <meta property="og:image" content="https://www.s9travels.com/images/keyword/67.jpg" />
      <meta property="og:url" content="https://www.s9travels.com/goa-to-pune-cab" />
      <meta property="og:type" content="website" />
      <script type="application/ld+json">{JSON.stringify(productSchema)}</script>
    </Helmet> 
    
    // Showing 4:3
    */}
        
       <Helmet>
  <title>Goa to Pune Cab Booking | AC Taxi & One-Way Rides – S9 Travels</title>
  <meta 
    name="description" 
    content="Book Goa to Pune Cabs with S9 Travels for safe, affordable, and on-time travel. One-way and round-trip AC cabs available with professional drivers. Instant booking, 24x7 support, and clean vehicles for your comfort." 
  />
  <meta 
    name="keywords" 
    content="Goa to Pune Cabs, Book Cab from Goa to Pune, One Way Goa to Pune Taxi, Goa to Pune AC Cab, Round Trip Taxi Goa to Pune, Car Hire Goa to Pune, Budget Cab Goa to Pune, Goa to Pune Travel Taxi, S9 Travels" 
  />
  <link rel="canonical" href="https://www.s9travels.com/Goa-To-Pune-Cab" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      
     
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/67.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Goatopunecab;